// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9875189b","977":"46855269"}[chunkId] + ".chunk.js";
};